import errorIllustration from '../../search/assets/images/no-content.svg';
import { Button, Divider, Form, Input, Spin } from 'antd';
import React, { useCallback } from 'react';
import _ from 'lodash';
import { notification } from '../../../utils/messaging';

export function AccountAlreadyActiveMessage({ className = '' }) {
  return (
    <div className={'grid-center txt-center ' + className}>
      <img src={errorIllustration} alt='No results' className='w-130' />
      <h2 className='sb-blue-900 gBold fs-20'>
        You have already set up your swimbooker account
      </h2>
      <p className='sb-blue-700 gSemiBold fs-16 max-w-230'>
        {
          'Your account is already active, please try logging in or resetting your password.'
        }
      </p>
      <Button
        style={{ width: 180 }}
        className='antd-link-button-override sb-blue-500 hover:sb-blue-700 mg-top-10 grey-border-200 hover:grey-border-300 br8 fs-16 h-fit gBold pd-top-10 pd-bottom-10 pd-left-20 pd-right-20'
        ghost
        href={'/user/profile'}
      >
        Go to Login
      </Button>
      <Button
        style={{ width: 180 }}
        className='antd-link-button-override sb-blue-500 hover:sb-blue-700 mg-top-10 grey-border-200 hover:grey-border-300 br8 fs-16 h-fit gBold pd-top-10 pd-bottom-10 pd-left-20 pd-right-20'
        ghost
        href={'/user/forgot_password'}
      >
        Forgot Password?
      </Button>
    </div>
  );
}

export function NewLinkSentMessage({ className = '' }) {
  return (
    <div className={'grid-center txt-center' + className}>
      <img src={errorIllustration} alt='No results' className='w-130' />
      <h2 className='sb-blue-900 gBold fs-20'>Your link has expired...</h2>
      <p className='sb-blue-700 gSemiBold fs-16 max-w-230 mg-bottom-0'>
        {
          "We've sent you an email with a new link, please follow the instructions in that email to finish setting up your account password."
        }
      </p>
    </div>
  );
}

export function AccountCreationErrorMessage({
  className = '',
  message = 'Something went wrong!',
  offerNewLink = false,
}) {
  return (
    <div className={'grid-center txt-center' + className}>
      <img src={errorIllustration} alt='No results' className='w-130' />
      <h2 className='sb-blue-900 gBold fs-20'>There was an issue...</h2>
      <p className='sb-blue-700 gSemiBold fs-16 max-w-230'>{message}</p>
      <Button
        className='sb-blue-500 hover:sb-blue-700 mg-top-10 grey-border-200 hover:grey-border-300 br8 fs-16 h-fit gBold pd-top-10 pd-bottom-10 pd-left-20 pd-right-20'
        ghost
        onClick={() => {
          if (offerNewLink) {
            window.location.href = '/user/forgot_password';
          } else {
            window.location.reload();
          }
        }}
      >
        {offerNewLink ? 'Get another link' : 'Reload Page'}
      </Button>
    </div>
  );
}

export function AccountCreationForm({
  userEmail,
  onFormSubmit,
  submitDisabled = false,
  emailFieldClass = '',
  fieldClass = '',
  showDivider = false,
  hideFieldLabels = false,
  passwordText = 'Set Password',
  buttonText = 'Create Account',
  buttonClass = 'sb-blue-bg white w-full gSemiBold fs-18 pd-10 h-fit br8 mg-top-20 ',
}) {
  const [form] = Form.useForm();

  const onFinish = useCallback(
    (formValues) => {
      if (!_.isEqual(formValues?.password, formValues?.['confirm-password'])) {
        notification.error({
          description: "Your passwords don't match. Please try again.",
        });
        return;
      }
      onFormSubmit({ email: userEmail, password: formValues.password });
    },
    [onFormSubmit, userEmail]
  );

  return (
    <Form
      onFinish={onFinish}
      layout='vertical'
      requiredMark={false}
      form={form}
      className='gMedium'
    >
      <Form.Item
        label={!hideFieldLabels && 'Email Address'}
        className='mg-bottom-10'
        disabled
      >
        <div
          className={
            'gMedium txt-left ant-input ant-input-disabled ' +
            emailFieldClass +
            ' ' +
            fieldClass
          }
        >
          {userEmail}
        </div>
      </Form.Item>
      {showDivider && <Divider />}
      <Form.Item
        label={!hideFieldLabels && passwordText}
        name='password'
        className='mg-bottom-10'
        required
        rules={[{ required: true, message: 'Please provide your password' }]}
      >
        <Input.Password
          className={fieldClass}
          placeholder={hideFieldLabels && 'Create your password'}
        />
      </Form.Item>
      <Form.Item
        label={!hideFieldLabels && 'Confirm Password'}
        name='confirm-password'
        className='mg-bottom-10'
        required
        rules={[{ required: true, message: 'Please confirm your password' }]}
      >
        <Input.Password
          className={fieldClass}
          placeholder={hideFieldLabels && 'Confirm your password'}
        />
      </Form.Item>

      <Button
        className={buttonClass}
        disabled={submitDisabled}
        htmlType='submit'
      >
        {submitDisabled ? <Spin /> : buttonText}
      </Button>
    </Form>
  );
}
